import { PropsWithChildren } from "react";
import styles from "./style.module.scss";

type DefaultLayoutType = PropsWithChildren & {
  navType: any;
};

const DefaultLayout: React.FC<DefaultLayoutType> = ({ navType, children }) => {
  return (
    <div className={styles.main}>
      <div className={styles.layout}>
        <div className={styles.contentContainer}>
          <div className={styles.container} id="containerElement">
            <div className={styles.pageContainer}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefaultLayout;
